import { useMemo, useState } from 'react';
import Button from '@mui/material/Button';
import { Menu, MenuItem, Checkbox, ListItemText } from '@mui/material';
import KeyboardArrowDownOutlined from '@mui/icons-material/KeyboardArrowDownOutlined';

export default function StatusFilterButton({
  statuses,
  selectedStatuses,
  onToggle,
  pillButtonSx
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const label = useMemo(() => {
    if (!selectedStatuses || selectedStatuses.length === 0) return null;
    return selectedStatuses
      .map(v => statuses.find(s => s.value === v)?.label)
      .filter(Boolean)
      .join(', ');
  }, [selectedStatuses, statuses]);

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        endIcon={<KeyboardArrowDownOutlined />}
        sx={{
          ...pillButtonSx,
          color: '#0A93D2',
          minWidth: '110px',
          padding: '10px 16px',
          fontWeight: '700',
          fontSize: '12px',
          '& .MuiButton-endIcon': { marginLeft: '6px', marginRight: 0 },
          '&:hover': {
            backgroundColor: '#ffffff',
            color: '#0A93D2',
            border: '1px solid #0A93D2'
          }
        }}
      >
        {label || 'Status'}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {statuses.map((status) => {
          const checked = selectedStatuses.includes(status.value);
          return (
            <MenuItem
              key={status.value}
              onClick={() => onToggle(status.value)}
              dense
            >
              <Checkbox checked={checked} />
              <ListItemText primary={status.label} />
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}